<template>
    <div>
        <h2>Voeg zelf een boek toe</h2>
        <form @submit="voegWensToe">
            <input type="text" v-model="titel" name="titel" placeholder="Titel">
            <input type="text"  v-model="auteur" name="auteur" placeholder="Auteur">
            <input type="number"  v-model="paginas" name="paginas" placeholder="aantal bladzijden">
            <input type="text"  v-model="ean" name="ean" placeholder="ean">
            <input type="text"  v-model="cover" name ="cover" placeholder="URL van cover">
            <input type="submit" value="Voeg toe">
            <hr>
        </form>
        
    </div>
</template>

<script>
export default {
    name: "MaakWens",
    data() {
        return {
            titel: '',
            auteur: '',
            paginas: '',
            ean: '',
            cover: ''
        }
    },
    methods: {
        // voordat de wens wordt toegevoegd moet eerst het object worden samengesteld.
        voegWensToe(e) {
            e.preventDefault();
            let nieuwBoek = {
                titel: this.titel,
                auteur: this.auteur,
                cover: this.cover,
                ean: this.ean,
                paginas: this.paginas,
                taal: "Nederlands",
                favoriet: false
            }
            // stuur naar App.vue
            this.$emit('voeg-boek-toe', nieuwBoek);
            // maak de formuliervelden weer leeg..
            this.titel   = '';
            this.auteur  = '';
            this.paginas = '';
            this.cover   = '';
            this. ean    = '';

        }
    }
}
</script>

<style scoped>
h2 {
    text-align: center;
    background-color: darkgreen;
    padding: 1em 0;
    color: rgb(193, 236, 221);
}
form {
    padding: 0 3em;
    background-color: darkgreen;
}
input {
    display: block;
    font-size: 1.5em;
    padding: .2em;
    margin-bottom: .5em;
    width: 100%;
}
input[type=submit] {
    width: auto;
    padding: .3em;
    font-size: 3.5em;
    margin-bottom: 2em;
    cursor: pointer;
}
</style>
